import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setCourseList, setCourseListError } from "../../repository/slice";

function* getCourseListWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/courses", payload);
        if (isError) {
            yield put(setCourseListError(message));
        } else {
            yield put(setCourseListError(null));
            yield put(setCourseList({list: data.rows, count: data.count}));
        }
    } catch (error) {
        console.error("getCourseListWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getCourseListWatcher() {
    yield takeLatest("@saga/GET_COURSE_LIST", getCourseListWorker);
};
